import React, { ComponentProps } from 'react'

import { styled } from '@mui/material'

import { CustomImage } from '../CustomImage/CustomImage'

export type ProductCarouselImageSlideProps = ComponentProps<typeof CustomImage> & {
  children: React.ReactNode
  index: number
  onImageClick: (index?: number) => void
}

export const ProductCarouselImageSlide: React.FC<ProductCarouselImageSlideProps> = ({ onImageClick, index, children, ...props }) => {
  const onClick = () => {
    onImageClick(index)
  }

  return (
    <StyledImage
      onClick={onClick}
      variant="square"
      noRatio
      objectFit="contain"
      loading={index === 0 ? 'eager' : 'lazy'}
      priority={index === 0}
      {...props}
    >
      {children}
    </StyledImage>
  )
}


const StyledImage = styled(CustomImage)`
  cursor: url("/icons/expand.svg"), pointer;
`
